module.exports = __webpack_public_path__ + "img/clap_off.ba94766b.svg";